import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { LinkItemWidget } from '../../../core/models';
import { SvgComponent } from '../svg/svg.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'sc-link-item-widget',
  imports: [SvgComponent, RouterLink],
  templateUrl: './link-item-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkItemWidgetComponent {
  linkItem = input<LinkItemWidget>(null);
  isAppUrl = computed(() => this.linkItem()?.url?.startsWith('/'));
  target = computed(() => (this.linkItem()?.isNewTab ? '_blank' : '_self'));
}
